export { default } from './carousel';


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmc-nuka-carousel/es/index.js
// module id = 833
// module chunks = 5